import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import CustomerForm from "../../CustomerForm";
import Dropzone from "react-dropzone";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { Controller, useForm } from "react-hook-form";
import LaiPhang from "../ModalSuaTraGop/LaiPhang";
import DuNoGiamDan from "../ModalSuaTraGop/DuNoGiamDan";
import { layKieuLaiSuatDuNoGoc } from "components/CommonComponent/ThemMoiTraGop/DuNoGiamDan";
import NumberInput from "components/GenericComponent/NumberInput";
import UploadMultiFile from "components/GenericComponent/UploadMultiFile";
import UploadMultiFile1 from "components/GenericComponent/UploadMultiFile1";
import { convertToNumber } from "utils/numberExtension";
import TextInputTwoRow from "components/GenericComponent/TextInputTwoRow";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import NumberFormat from "react-number-format";
import ListTaiSanForm from "components/CommonComponent/ListTaiSanForm";
import TaiSanApi from "service/taiSanApi";
import CauHinhApi from "service/cauHinhApi";
import cauHinh from "utils/cauHinh";
import { pushNotification } from "utils/notifications";
import ThemMoiLoaiTaiSanContainer from "containers/Common/TaiSan/ThemMoiLoaiTaiSanContainer";
const ThemMoiTraGop = (props) => {
  let {
    show,
    customer,
    getAutocompleteCustomer,
    user,
    phikhac,
    phikhachangky,
    nguonkhachhang,
    postTraGop,
    onHide,
    cauhinh,
    getDetailCustomer,
    themmoitragop,
    setChoVayEdit,
    phanquyen,
    inHopDong,
    inPhieuThu,
    checkEditCustomer,
    setEnableEditCustomer,
    getDetailCustomerSuccess,
    quanlycuahang,
    thuoctinhtaisan,
    store,
    loaitaisan,
    setTaiSanTraGop,
    showModalLoaiTaiSan,
    getComboLoaiTaiSan,
    getThuocTinhTaiSan,
    getThuocTinhTaiSan1,
    getComboStore,
  } = props;
  let { comboNguonKhachHang } = nguonkhachhang;
  let { objThuocTinhTaiSan, objThuocTinhTaiSan1, thuocTinhTaiSanLoaded } =
    thuoctinhtaisan || {};
  let { objComboStore } = store || {};
  let { comboLoaiTaiSan, comboLoaiTaiSanLoaded, isShowModalLoaiTaiSan } =
    loaitaisan || {};
  let ListLoaiTaiSan = comboLoaiTaiSan || [];
  let {
    ConfigTMTG,
    choVayEdit,
    setListPhiKhac,
    postTraGopLoading,
    postTraGopReturn,
    TaiSanTraGop,
    isShowFormTraGop,
  } = themmoitragop;
  let NoteTaiSan = TaiSanTraGop.Note;
  let AnhTaiSan = TaiSanTraGop.AnhTaiSan;
  let { CategoryId, TenTaiSan, StoreID, PhiKho, LoaiTaiSan } = TaiSanTraGop;
  let MaTaiSan = TaiSanTraGop.Code || TaiSanTraGop.MaTaiSan;
  let { objConfig } = cauhinh;
  let ConfigPhiKho = objConfig.PhiKho;
  let objConfigSysLoaiTS = ConfigTMTG;
  let {
    LaiSuat,
    TypePaid,
    ChoVayId,
    CountTypePaid,
    BeforeAfter,
    NgayVay,
    KieuLaiSuat,
    Sotienvay,
    SoLanTra,
    SoNgayToiThieu,
    SoNgayGiaHan,
    PhiDongLaiCham,
    CustomerID,
    Note,
    NgayTra,
    TongNgayVay,
    IsCopy,
    showButtonIn,
    showButtonInPhieuThu,
    ThuChiId,
    IsEditChoVay,
    IsEditCustomer,
    Code,
    IsDuNoGiamDan,
    ValueLai,
    PhiPhatTraLai,
    LoaiPhiPhatTraLai,
    PhiPhatTatToan,
    LoaiPhiPhatTatToan,
    MaNhanVien,
    TypeDuNo,
  } = choVayEdit;
  let { LinkDinhKem } = props.data;
  IsEditChoVay = !IsEditChoVay;
  const selectedTypeDuNo = TypeDuNo ? parseInt(TypeDuNo, 10) : 1;
  //Đơn vị chi phí vay theo KieuLaiSuat đã lưu trên hợp đồng (null hoặc 1 = % Ngày, 3 = % Tháng)
  const chiPhiVayTheoNgay = KieuLaiSuat == null || Number(KieuLaiSuat) === 1;

  const [isSetPhiKhac, setIsSetPhiKhac] = useState(null);
  const [isSetPhiKhacHangKy, setIsSetPhiKhacHangKy] = useState(null);
  const [imageTaiSans, setImageTaiSans] = useState([]);
  const [anhTaiSan, setAnhTaiSan] = useState([]);
  const [fileDinhKems, setFileDinhKems] = useState([]);
  const [linkDinhKem, setLinkDinhKem] = useState("");
  const [curentNoteTaiSan, setCurentNoteTaiSan] = useState([]);
  const [currentChoVay, setCurrentChoVay] = useState({});
  const [currentCode, setCode] = useState(null);
  const [ChonLoaiPhiKhac, setChonLoaiPhiKhac] = useState(false);
  const [ChonLoaiPhiKhacHangKy, setChonLoaiPhiKhacHangKy] = useState(false);
  const [intLoaiPhiPhatTraLai, setLoaiPhiPhatTraLai] = useState(1);
  const [intLoaiPhiPhatTatToan, setLoaiPhiPhatTatToan] = useState(1);
  const [isCauHinhT77, setisCauHinhT77] = useState(false);
  const [isDuNoGocCoDinh, setDuNoGocCoDinh] = useState(false);
  const [isMoney88, setIsMoney88] = useState(false);
  const [ThuocTinhTaiSan, setThuocTinhTaiSan] = useState([]);
  const [ListTaiSanCamCo, setListTaiSanCamCo] = useState([]);
  const [showAddNewTaiSan, setShowAddNewTaiSan] = useState(false);
  let currentForm = useForm({
    CountTypePaid: CountTypePaid,
    Sotienvay: Sotienvay,
    SoLanTra: SoLanTra,
    SoNgayToiThieu: SoNgayToiThieu,
    SoNgayGiaHan: SoNgayGiaHan,
    NoteTaiSan: NoteTaiSan,
    PhiDongLaiCham: PhiDongLaiCham,
    Code: Code,
  });
  const { register, handleSubmit, errors, control, setValue } = currentForm; // initialize the hook
  let { objListPhiKhac } = phikhac;
  let { objListPhiKhacHangKy } = phikhachangky;
  let { thongTinCuaHang } = quanlycuahang ? quanlycuahang : {};
  useEffect(() => {
    if (choVayEdit.ChoVayId > 0) {
      setLoaiPhiPhatTraLai(choVayEdit.LoaiPhiPhatTraLai);
      setLoaiPhiPhatTatToan(choVayEdit.LoaiPhiPhatTatToan);
    }
    if (currentChoVay.CountTypePaid !== CountTypePaid) {
      setValue("CountTypePaid", CountTypePaid);
      currentChoVay.CountTypePaid = CountTypePaid;
    }
    if (currentChoVay.TypePaid !== TypePaid) {
      setValue("TypePaid", TypePaid);
      currentChoVay.TypePaid = TypePaid;
    }
    if (currentChoVay.ValueLai !== ValueLai) {
      setValue("ValueLai", ValueLai);
      currentChoVay.ValueLai = ValueLai;
    }
    if (
      currentChoVay.CountTypePaid !== CountTypePaid ||
      currentChoVay.TypePaid !== TypePaid
    )
      setCurrentChoVay(currentChoVay);
    if (
      (Code && Code !== currentCode) ||
      (showButtonIn && currentCode === null)
    ) {
      setValue("Code", Code);
      setCode(Code);
    }
    if (AnhTaiSan && AnhTaiSan !== anhTaiSan) {
      setAnhTaiSan(AnhTaiSan);
      setImageTaiSans(AnhTaiSan.split(";"));
    }
    if (curentNoteTaiSan && curentNoteTaiSan !== NoteTaiSan) {
      setCurentNoteTaiSan(curentNoteTaiSan);
      setValue("NoteTaiSan", NoteTaiSan);
    }
    if (linkDinhKem != LinkDinhKem) {
      setFileDinhKems(LinkDinhKem ? LinkDinhKem.split(";") : []);
      setLinkDinhKem(LinkDinhKem);
    }
    console.log(errors);
  }, [
    currentChoVay,
    CountTypePaid,
    LaiSuat,
    TypePaid,
    KieuLaiSuat,
    Code,
    currentCode,
    showButtonIn,
    isSetPhiKhac,
    objListPhiKhac,
    AnhTaiSan,
    anhTaiSan,
    curentNoteTaiSan,
    NoteTaiSan,
    setValue,
    ValueLai,
    errors,
  ]);
  useEffect(() => {
    if (
      !isSetPhiKhac &&
      objListPhiKhac.length > 0 &&
      objListPhiKhac[0].GiaTri !== undefined
    ) {
      setIsSetPhiKhac(true);
      for (let index = 0; index < objListPhiKhac.length; index++) {
        const element = objListPhiKhac[index];
        setValue("ListPhiKhac[" + index + "].GiaTri", element.GiaTri);
        setValue("ListPhiKhac[" + index + "].LoaiPhiKhac", element.LoaiPhiKhac);
        setValue(
          "ListPhiKhac[" + index + "].LoaiPhiKhacChon",
          element.LoaiPhiKhacChon
        );
      }
    }

    if (
      !isSetPhiKhacHangKy &&
      objListPhiKhacHangKy.length > 0 &&
      objListPhiKhacHangKy[0].GiaTri !== undefined
    ) {
      setIsSetPhiKhacHangKy(true);
      for (let index = 0; index < objListPhiKhacHangKy.length; index++) {
        const element = objListPhiKhacHangKy[index];
        setValue("ListPhiKhacHangKy[" + index + "].GiaTri", element.GiaTri);
        setValue(
          "ListPhiKhacHangKy[" + index + "].LoaiPhiKhacHangKy",
          element.LoaiPhiKhacHangKy
        );
        setValue(
          "ListPhiKhacHangKy[" + index + "].LoaiPhiKhacHangKyChon",
          element.LoaiPhiKhacHangKyChon
        );
      }
    }

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onHide(); // Gọi hàm đóng popup
      }
    };

    // Thêm sự kiện lắng nghe khi component được mount
    document.addEventListener("keydown", handleEscape);

    // Dọn dẹp sự kiện khi component unmount
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [onHide]);

  useEffect(() => {
    CauHinhApi.getConfigSys1().then((response) => {
      if (response.status === 200 && response.data.length > 0) {
        const laBat = (key) => {
          const config = response.data.find(
            (e) =>
              e.keyConfig && e.keyConfig.toUpperCase() === key.toUpperCase()
          );
          return config != null && config.valueConfig === "1";
        };
        setisCauHinhT77(laBat(cauHinh.sKey.IsCauHinhT77));
        setDuNoGocCoDinh(laBat(cauHinh.sKey.DuNoGiamDanLaiGiamDan));
        setIsMoney88(laBat(cauHinh.sKey.IsMoney88));
      }
    });
  }, []);

  useEffect(() => {
    if (!isCauHinhT77) return;
    if (!comboLoaiTaiSanLoaded || ListLoaiTaiSan.length === 0) {
      getComboLoaiTaiSan({ trangThai: "" });
    }
    getComboStore();
  }, [isCauHinhT77, comboLoaiTaiSanLoaded, ListLoaiTaiSan.length]);

  useEffect(() => {
    if (
      TaiSanTraGop.ThuocTinhTaiSan &&
      TaiSanTraGop.ThuocTinhTaiSan.length > 0
    ) {
      setThuocTinhTaiSan(TaiSanTraGop.ThuocTinhTaiSan);
    } else {
      setThuocTinhTaiSan(objThuocTinhTaiSan1 || []);
    }
  }, [objThuocTinhTaiSan1, TaiSanTraGop.ThuocTinhTaiSan]);

  useEffect(() => {
    if (
      isCauHinhT77 &&
      ListLoaiTaiSan.length > 0 &&
      (LoaiTaiSan === null ||
        typeof LoaiTaiSan === "undefined" ||
        LoaiTaiSan === "")
    ) {
      const defaultLoaiTaiSan = ListLoaiTaiSan[0].value;
      setTaiSanTraGop({
        ...TaiSanTraGop,
        LoaiTaiSan: defaultLoaiTaiSan,
      });
      getThuocTinhTaiSan1({ loaiTaiSan: defaultLoaiTaiSan });
    }
  }, [isCauHinhT77, ListLoaiTaiSan.length, LoaiTaiSan]);

  useEffect(() => {
    if (
      isCauHinhT77 &&
      objComboStore &&
      objComboStore.length > 0 &&
      (StoreID === null || typeof StoreID === "undefined" || StoreID === "")
    ) {
      setTaiSanTraGop({
        ...TaiSanTraGop,
        StoreID: objComboStore[0].value,
      });
    }
  }, [isCauHinhT77, objComboStore, StoreID]);

  //Tài sản đầu tiên đổ vào TaiSanTraGop (saga showFormTraGop), các tài sản còn lại vào danh sách tài sản khác
  useEffect(() => {
    if (!isCauHinhT77 || !(ChoVayId > 0)) return;
    TaiSanApi.taiSanTheoChoVay({ chovayId: ChoVayId }).then((response) => {
      if ((response.ok || response.status === 200) && response.data) {
        const data = Array.isArray(response.data) ? response.data : [];
        setListTaiSanCamCo(data.slice(1));
        if (data.length > 1) {
          setShowAddNewTaiSan(true);
        }
      } else {
        pushNotification(
          "Lỗi. Không lấy được tài sản theo cho vay.",
          "error",
          "TOP_CENTER",
          1000
        );
      }
    });
  }, [isCauHinhT77, ChoVayId]);

  const setAttTaiSan = (field) => (evt) => {
    setTaiSanTraGop({
      ...TaiSanTraGop,
      [field]: evt.target.value,
    });
  };

  const onChangeLoaiTaiSan = (evt) => {
    let loaiTaiSan = evt.target.value;
    setThuocTinhTaiSan([]);
    setTaiSanTraGop({
      ...TaiSanTraGop,
      LoaiTaiSan: loaiTaiSan,
      ThuocTinhTaiSan: [],
    });
    getThuocTinhTaiSan1({ loaiTaiSan });
  };

  const onChangeThuocTinhTaiSan = (index) => (evt) => {
    let listThuocTinh = ThuocTinhTaiSan.slice();
    listThuocTinh[index].OptionValue = evt.target.value;
    setThuocTinhTaiSan(listThuocTinh);
  };

  const onChangeListTaiSan = (listTaiSan) => {
    setListTaiSanCamCo(listTaiSan.slice());
  };

  const onClickShowAddNewTaiSan = () => {
    setShowAddNewTaiSan(!showAddNewTaiSan);
  };

  const hideModalLoaiTaiSan = () => {
    showModalLoaiTaiSan(false);
  };

  const onChangeTypeDuNo = () => (evt) => {
    choVayEdit.TypeDuNo = parseInt(evt.target.value, 10);
    setChoVayEdit(choVayEdit);
  };

  //Chọn kỳ của Thời gian vay (Ngày/Tuần/Tháng định kỳ/Tháng) - dùng cho Dư nợ gốc bằng nhau của isMoney88
  const onChangeTypePaidTraGop = () => (evt) => {
    choVayEdit.TypePaid = parseInt(evt.target.value, 10);
    setValue("TypePaid", choVayEdit.TypePaid);
    setChoVayEdit({ ...choVayEdit });
  };

  const onChangeBeforeAfterDuNoGoc = () => (evt) => {
    choVayEdit.BeforeAfter = parseInt(evt.target.value, 10);
    setChoVayEdit({ ...choVayEdit });
  };

  const onChangeKieuLaiSuatDuNoGoc = () => (evt) => {
    choVayEdit.KieuLaiSuat = parseInt(evt.target.value, 10);
    setChoVayEdit({ ...choVayEdit });
  };

  const onChangeAttNumberChoVay = (field) => (evt) => {
    choVayEdit[field] = evt.target.value;
    setValue(field, evt.target.value);
    if (field === "Sotienvay") {
      choVayEdit.ValueHoaHong = (convertToNumber(evt.target.value) * 1.2) / 100;
      setValue("ValueHoaHong", choVayEdit.ValueHoaHong);
    }
    setChoVayEdit(choVayEdit);
  };
  const onChangeAttTextChoVay = (field) => (evt) => {
    choVayEdit[field] = evt.target.value;
    setValue(field, evt.target.value);
    setChoVayEdit(choVayEdit);
  };
  const onChangeTypePaid = () => (evt) => {
    if (evt.target.checked) {
      choVayEdit.TypePaid = 2;
    } else {
      choVayEdit.TypePaid = 1;
    }
    setChoVayEdit(choVayEdit);
  };
  const onChangeStatusPaidHo = () => (evt) => {
    choVayEdit.StatusPaidHo = parseInt(evt.target.value);
    setChoVayEdit(choVayEdit);
  };
  let { PhanQuyenTraGop } = phanquyen;
  let { chonngaygiaodich, laiho_sudungchoduyet } = PhanQuyenTraGop;
  let { _allTraThieuTraDuTraGop } = ConfigTMTG ? ConfigTMTG : {};

  const onSubmit = (dataChoVay) => {
    if (isCauHinhT77 && (!TenTaiSan || !TenTaiSan.trim())) {
      pushNotification(
        "Vui lòng nhập tên tài sản",
        "error",
        "TOP_CENTER",
        1000
      );
      return;
    }

    dataChoVay.ImageList = imageTaiSans.map(function (elem) {
      if (typeof elem.url !== "undefined") {
        return elem.url;
      } else {
        return elem;
      }
    });

    if (isCauHinhT77) {
      if (!dataChoVay.ListHangTheChap) {
        dataChoVay.ListHangTheChap = [{}];
      }
      if (!dataChoVay.ListHangTheChap[0]) {
        dataChoVay.ListHangTheChap[0] = {};
      }
      dataChoVay.ListHangTheChap[0].CategoryId = CategoryId;
      dataChoVay.ListHangTheChap[0].TenTaiSan = TenTaiSan;
      if (
        LoaiTaiSan !== null &&
        typeof LoaiTaiSan !== "undefined" &&
        LoaiTaiSan !== ""
      ) {
        dataChoVay.ListHangTheChap[0].LoaiTaiSan = LoaiTaiSan;
      } else if (
        !dataChoVay.ListHangTheChap[0].LoaiTaiSan &&
        ListLoaiTaiSan.length > 0
      ) {
        dataChoVay.ListHangTheChap[0].LoaiTaiSan = ListLoaiTaiSan[0].value;
      }
      dataChoVay.ListHangTheChap[0].StoreID = StoreID;
      dataChoVay.ListHangTheChap[0].Code = MaTaiSan;
      dataChoVay.ListHangTheChap[0].PhiKho = PhiKho;
      if (!dataChoVay.ListHangTheChap[0].ThuocTinhTaiSan) {
        dataChoVay.ListHangTheChap[0].ThuocTinhTaiSan = ThuocTinhTaiSan;
      }
      dataChoVay.ListHangTheChap[0].Note = NoteTaiSan;
      dataChoVay.ListHangTheChap[0].AnhTaiSan = dataChoVay.ImageList.join(";");
      let listTSpost = ListTaiSanCamCo.slice();
      listTSpost.unshift(dataChoVay.ListHangTheChap[0]);
      dataChoVay.ListHangTheChap = listTSpost;
    }
    //Không gửi thì backend nhận TypeDuNo = 0: HĐ "Gốc cố định - Lãi giảm dần" bị chuyển về trả đều khi sửa
    dataChoVay.TypeDuNo = selectedTypeDuNo;
    dataChoVay.TypePaid = choVayEdit.TypePaid;
    //Không gửi thì backend coi là thu lãi sau, % Định kỳ, kỳ 1: HĐ Dư nợ gốc bằng nhau bị đổi khi sửa
    if (isMoney88 && IsDuNoGiamDan && selectedTypeDuNo === 2) {
      dataChoVay.BeforeAfter = Number(choVayEdit.BeforeAfter) === 2 ? 2 : 1;
      dataChoVay.KieuLaiSuat = layKieuLaiSuatDuNoGoc(
        choVayEdit.TypePaid,
        choVayEdit.KieuLaiSuat
      );
    }
    if (dataChoVay.CountTypePaid != undefined)
      dataChoVay.CountTypePaid = String(dataChoVay.CountTypePaid).replace(
        ",",
        ""
      );
    dataChoVay.StatusPaidHo = choVayEdit.StatusPaidHo;
    dataChoVay.IsDuNoGiamDan = IsDuNoGiamDan;
    dataChoVay.FileDinhKems = fileDinhKems
      .map(function (elem) {
        if (typeof elem.url !== "undefined") {
          return elem.url;
        } else {
          return elem;
        }
      })
      .join(";");
    dataChoVay.LoaiPhiPhatTraLai = choVayEdit.LoaiPhiPhatTraLai;
    dataChoVay.LoaiPhiPhatTatToan = choVayEdit.LoaiPhiPhatTatToan;
    dataChoVay.MaNhanVien = choVayEdit.MaNhanVien;
    postTraGop({
      ChoVay: dataChoVay,
      Customer: dataChoVay.customer,
      IsChoDuyet: laiho_sudungchoduyet,
    });
  };

  const onChangeNgayVay = (evt) => {
    choVayEdit.NgayVay = evt;
    setChoVayEdit(choVayEdit);
  };
  const onChangeNgayThanhToan = (evt) => {
    choVayEdit.NgayThanhToan = evt;
    setChoVayEdit(choVayEdit);
  };

  const onChangePhiKhac = (configId) => (evt) => {
    if (evt.target.value != undefined) {
      objListPhiKhac[configId].GiaTri = evt.target.value;
      if (setListPhiKhac != undefined) setListPhiKhac(objListPhiKhac);
    }
  };

  const onChangeLoaiPhiKhac = (configId, val) => (evt) => {
    objListPhiKhac[configId].LoaiPhiKhacChon = val;
    if (setListPhiKhac != undefined) setListPhiKhac(objListPhiKhac);
    setChonLoaiPhiKhac(!ChonLoaiPhiKhac);
  };

  const onChangePhiKhacHangKy = (configId) => (evt) => {
    objListPhiKhacHangKy[configId].GiaTri = evt.value;
  };

  const onChangeLoaiPhiKhacHangKy = (configId, val) => (evt) => {
    objListPhiKhacHangKy[configId].LoaiPhiKhacHangKyChon = val;
    setChonLoaiPhiKhacHangKy(!ChonLoaiPhiKhacHangKy);
  };

  const onChangeLoaiPhiPhatTraLai = (val) => (evt) => {
    setLoaiPhiPhatTraLai(val);
    choVayEdit.LoaiPhiPhatTraLai = val;
    setChoVayEdit(choVayEdit);
  };

  const onChangeLoaiPhiPhatTatToan = (val) => (evt) => {
    setLoaiPhiPhatTatToan(val);
    choVayEdit.LoaiPhiPhatTatToan = val;
    setChoVayEdit(choVayEdit);
  };

  const closeThemMoi = () => () => {
    getDetailCustomerSuccess({});
    onHide();
  };
  if (postTraGopReturn) {
    getDetailCustomerSuccess({});
    onHide();
  }
  let { autocompleteData } = customer;
  let { combo } = user;
  let showLaiPhang = false;
  let showDuNoGiamDan = false;
  if (IsDuNoGiamDan !== undefined) {
    showLaiPhang = !IsDuNoGiamDan;
    showDuNoGiamDan = IsDuNoGiamDan;
  }
  return (
    <>
      <Modal
        show={show}
        size="modal-new-size modal-new-size"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left popup-detail"
      >
        <div
          className={
            "loader loader-default " + (postTraGopLoading ? "is-active" : "")
          }
        ></div>
        <form
          className="form tat-toan form-horizontal form-edit"
          onSubmit={handleSubmit(onSubmit)}
        >
          <Modal.Header>
            <h4 className="modal-title  color7-bold" id="myModalLabel16">
              <span className="btn-icon-right">
                <img src="/app-assets/images/icon-them-moi-hop-dong-v2.png" />
              </span>{" "}
              {ChoVayId > 0 ? "Cập nhật" : "Thêm mới"} hợp đồng trả góp
            </h4>
            <button
              type="button"
              className="close-popup-new"
              data-dismiss="modal"
              aria-label="Close"
              onClick={closeThemMoi()}
            >
              <img src="/app-assets/images/icon-dong-popup-v2.png" />
            </button>
          </Modal.Header>
          <Modal.Body
            style={{ padding: "0px", background: "#F4F5FA !important" }}
          >
            <div className="form tat-toan form-horizontal form-edit thoimoihopdong">
              <div className="form-body">
                <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                  <div
                    id="headingCollapse196"
                    className="card-header"
                    data-toggle="collapse"
                    href="#collapse196"
                    aria-expanded="true"
                    aria-controls="collapse196"
                  >
                    <a
                      className="card-title lead info collapsed"
                      href={() => false}
                    >
                      <h3>Thông tin khách vay</h3>
                    </a>
                  </div>
                  <div
                    id="collapse196"
                    aria-labelledby="headingCollapse96"
                    className="card-collapse collapse show"
                    aria-expanded="true"
                  >
                    <CustomerForm
                      customerId={CustomerID}
                      currentForm={currentForm}
                      autocompleteData={autocompleteData}
                      getAutocompleteCustomer={getAutocompleteCustomer}
                      userCombo={combo}
                      comboNguonKhachHang={comboNguonKhachHang}
                      customer={customer}
                      getDetailCustomer={getDetailCustomer}
                      errors={errors}
                      IsEditCustomer={IsEditCustomer}
                      checkEditCustomer={checkEditCustomer}
                      setEnableEditCustomer={setEnableEditCustomer}
                      IsCopy={IsCopy}
                      CodeCuaHang={thongTinCuaHang.Code}
                    ></CustomerForm>
                  </div>
                </div>
                <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                  <div
                    id="headingCollapse194"
                    className="card-header  mt-1"
                    data-toggle="collapse"
                    href="#collapse194"
                    aria-expanded="true"
                    aria-controls="collapse194"
                  >
                    <a
                      className="card-title lead info collapsed"
                      href={() => false}
                    >
                      <h3>Thông tin cho vay</h3>
                    </a>
                  </div>
                  <div
                    id="collapse194"
                    aria-labelledby="headingCollapse94"
                    className="card-collapse collapse show"
                    aria-expanded="true"
                  >
                    <div className="card-content">
                      <div className="card-body">
                        <div className="row">
                          <input
                            type="hidden"
                            name="ChoVayId"
                            value={ChoVayId}
                            ref={register}
                          ></input>
                          <div className="col-md-12 col-lg-12">
                            {ConfigTMTG &&
                              ConfigTMTG._duNoGiamDanTraGop === true &&
                              isDuNoGocCoDinh &&
                              IsDuNoGiamDan && (
                                <div
                                  className="row"
                                  style={{ marginBottom: "10px" }}
                                >
                                  <div className="col-md-4">
                                    <label class="color7-bold">
                                      Loại giảm dần
                                    </label>
                                    <select
                                      ref={register}
                                      className="form-control input-sm"
                                      onChange={onChangeTypeDuNo()}
                                      value={selectedTypeDuNo}
                                      defaultValue={selectedTypeDuNo}
                                      disabled={
                                        IsEditChoVay || !_allTraThieuTraDuTraGop
                                      }
                                      name="TypeDuNo"
                                    >
                                      <option value="1">
                                        {isMoney88
                                          ? "Dư nợ trả góp"
                                          : "Trả đều (Tổng cố định)"}
                                      </option>
                                      <option value="2">
                                        {isMoney88
                                          ? "Dư nợ gốc bằng nhau"
                                          : "Gốc cố định - Lãi giảm dần"}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              )}
                            {isCauHinhT77 && (
                              <div className="row">
                                <div className="col-md-4">
                                  <label className="label-control color7-bold">
                                    Tên tài sản{" "}
                                    <span className="canh-bao-red">*</span>
                                  </label>
                                  <fieldset>
                                    <div className="input-group">
                                      <input
                                        type="text"
                                        name="ListHangTheChap[0].TenTaiSan"
                                        value={TenTaiSan || ""}
                                        className="form-control input-sm"
                                        onChange={setAttTaiSan("TenTaiSan")}
                                        readOnly={IsEditChoVay}
                                        ref={register({
                                          required: "Vui lòng nhập tên tài sản",
                                        })}
                                      ></input>
                                    </div>
                                  </fieldset>
                                  <span className="canh-bao-red">
                                    {errors.ListHangTheChap &&
                                      errors.ListHangTheChap[0] &&
                                      errors.ListHangTheChap[0].TenTaiSan &&
                                      errors.ListHangTheChap[0].TenTaiSan.message}
                                  </span>
                                </div>
                                <div className="col-md-4">
                                  <label className="label-control color7-bold">
                                    Loại tài sản{" "}
                                    <span className="canh-bao-red">*</span>
                                  </label>
                                  <br />
                                  <select
                                    name="ListHangTheChap[0].LoaiTaiSan"
                                    className="form-control input-sm col-md-12  select-v2"
                                    ref={register}
                                    value={LoaiTaiSan}
                                    onChange={onChangeLoaiTaiSan}
                                    defaultValue={LoaiTaiSan}
                                    disabled={IsEditChoVay}
                                  >
                                    {ListLoaiTaiSan &&
                                      ListLoaiTaiSan.map((item, idx) => (
                                        <option
                                          key={"comboLoaiTaiSan" + idx}
                                          value={item.value}
                                        >
                                          {item.label}
                                        </option>
                                      ))}
                                  </select>
                                </div>
                                <div className="col-md-4">
                                  <label className="label-control color7-bold">
                                    &nbsp;
                                  </label>
                                  <br />
                                  <div>
                                    <button
                                      type="button"
                                      className="btn-them-moi-ts"
                                      onClick={() => showModalLoaiTaiSan(true)}
                                      style={{ margin: "0px" }}
                                    >
                                      <i className="mdi mdi-plus"></i>{" "}
                                      <span style={{ fontSize: "15px" }}>
                                        Thêm mới loại tài sản
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="row thongtinchovay-v2">
                              {showLaiPhang && (
                                <LaiPhang
                                  func={{
                                    onChangeNgayVay: onChangeNgayVay,
                                    onChangeAttNumberChoVay:
                                      onChangeAttNumberChoVay,
                                    onChangeTypePaid: onChangeTypePaid,
                                    onChangeAttTextChoVay: onChangeAttTextChoVay,
                                    onChangeStatusPaidHo: onChangeStatusPaidHo,
                                    onChangeNgayThanhToan: onChangeNgayThanhToan,
                                  }}
                                  data={choVayEdit}
                                  register={register}
                                  chonngaygiaodich={chonngaygiaodich}
                                  IsEditChoVay={IsEditChoVay}
                                  control={control}
                                  errors={errors}
                                  config={ConfigTMTG}
                                ></LaiPhang>
                              )}
                              {showDuNoGiamDan && (
                                <DuNoGiamDan
                                  func={{
                                    onChangeNgayVay: onChangeNgayVay,
                                    onChangeAttNumberChoVay:
                                      onChangeAttNumberChoVay,
                                    onChangeTypePaid: onChangeTypePaid,
                                    onChangeTypePaidTraGop:
                                      onChangeTypePaidTraGop,
                                    onChangeBeforeAfterDuNoGoc:
                                      onChangeBeforeAfterDuNoGoc,
                                    onChangeKieuLaiSuatDuNoGoc:
                                      onChangeKieuLaiSuatDuNoGoc,
                                    onChangeAttTextChoVay: onChangeAttTextChoVay,
                                    onChangeStatusPaidHo: onChangeStatusPaidHo,
                                    onChangeNgayThanhToan: onChangeNgayThanhToan,
                                  }}
                                  data={choVayEdit}
                                  register={register}
                                  chonngaygiaodich={chonngaygiaodich}
                                  IsEditChoVay={IsEditChoVay}
                                  control={control}
                                  errors={errors}
                                  config={ConfigTMTG}
                                  TypeDuNo={selectedTypeDuNo}
                                  isMoney88={isMoney88}
                                  chiPhiVayTheoNgay={chiPhiVayTheoNgay}
                                ></DuNoGiamDan>
                              )}
                              {props.isDuDungPhiPhatDongLaiTatToan && (
                                <>
                                  <div className="col-md-12"></div>
                                  <div className="col-md-4">
                                    <NumberInput
                                      labelClass="col-md-6 label-control"
                                      inputClass="form-control input-sm"
                                      inputWrapClass="col-md-6"
                                      labelText="Phạt chậm đóng lãi"
                                      wrapperClass="form-group row"
                                      inputProps={{
                                        name: "PhiPhatTraLai",
                                        value: PhiPhatTraLai,
                                        onChange:
                                          onChangeAttNumberChoVay(
                                            "PhiPhatTraLai"
                                          ),
                                        control: control,
                                        readOnly: IsEditChoVay,
                                      }}
                                    ></NumberInput>
                                  </div>
                                  <div className="col-md-4 radio-button-nhap-tien">
                                    <label className="custom-radio">
                                      <input
                                        type="radio"
                                        name="LoaiPhiPhatTraLai"
                                        onChange={onChangeLoaiPhiPhatTraLai(1)}
                                        checked={
                                          intLoaiPhiPhatTraLai === 1
                                            ? true
                                            : false
                                        }
                                        disabled={IsEditChoVay}
                                      />{" "}
                                      <span className="radio-mark"></span>
                                      Nhập tiền
                                    </label>
                                    <label className="custom-radio radio-button-nhap-phan-tram">
                                      <input
                                        type="radio"
                                        name="LoaiPhiPhatTraLai"
                                        onChange={onChangeLoaiPhiPhatTraLai(2)}
                                        checked={
                                          intLoaiPhiPhatTraLai === 2
                                            ? true
                                            : false
                                        }
                                        disabled={IsEditChoVay}
                                      />{" "}
                                      <span className="radio-mark"></span>
                                      Nhập %
                                    </label>
                                  </div>
                                  <div className="col-md-4"></div>
                                </>
                              )}
                              {props.isSuDungTatToanSom && (
                                <>
                                  <div className="col-md-4">
                                    <NumberInput
                                      labelClass="col-md-6 label-control"
                                      inputClass="form-control input-sm"
                                      inputWrapClass="col-md-6"
                                      labelText="Phạt tất toán sớm"
                                      wrapperClass="form-group row"
                                      inputProps={{
                                        name: "PhiPhatTatToan",
                                        value: PhiPhatTatToan,
                                        onChange:
                                          onChangeAttNumberChoVay(
                                            "PhiPhatTatToan"
                                          ),
                                        control: control,
                                        readOnly: IsEditChoVay,
                                      }}
                                    ></NumberInput>
                                  </div>
                                  <div className="col-md-4 radio-button-nhap-tien">
                                    <label className="custom-radio">
                                      <input
                                        type="radio"
                                        name="LoaiPhiPhatTatToan"
                                        onChange={onChangeLoaiPhiPhatTatToan(1)}
                                        checked={
                                          intLoaiPhiPhatTatToan === 1
                                            ? true
                                            : false
                                        }
                                        disabled={IsEditChoVay}
                                      />{" "}
                                      <span className="radio-mark"></span>
                                      Nhập tiền
                                    </label>
                                    <label className="custom-radio radio-button-nhap-phan-tram">
                                      <input
                                        type="radio"
                                        name="LoaiPhiPhatTatToan"
                                        onChange={onChangeLoaiPhiPhatTatToan(2)}
                                        checked={
                                          intLoaiPhiPhatTatToan === 2
                                            ? true
                                            : false
                                        }
                                        disabled={IsEditChoVay}
                                      />{" "}
                                      <span className="radio-mark"></span>
                                      Nhập %
                                    </label>
                                  </div>
                                  <div className="col-md-4"></div>
                                </>
                              )}
                              <div className="col-md-12"></div>
                              {props.isSuDungCongTacVienNhanVien && (
                                <div className="col-md-4">
                                  <TextInputTwoRow
                                    labelClass="col-md-2 label-control"
                                    inputClass="form-control input-sm"
                                    inputWrapClass="col-md-4"
                                    wrapperClass="form-group row"
                                    labelText="Mã nhân viên"
                                    placeholder="Mã nhân viên"
                                    inputProps={{
                                      name: "MaNhanVien",
                                      onChange:
                                        onChangeAttTextChoVay("MaNhanVien"),
                                      value: MaNhanVien,
                                    }}
                                  ></TextInputTwoRow>
                                </div>
                              )}
                              <div className="col-md-12">
                                <label className="label-control color7-bold">
                                  Ghi chú
                                </label>
                                <textarea
                                  rows="2"
                                  style={{ minHeight: "80px" }}
                                  className="form-control input-sm"
                                  name="Note"
                                  placeholder=""
                                  value={Note}
                                  onChange={onChangeAttTextChoVay("Note")}
                                  ref={register}
                                  disabled={IsEditChoVay}
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                  <div
                    id="headingCollapse9416"
                    className="card-header  mt-1"
                    data-toggle="collapse"
                    href="#collapse19417"
                    aria-expanded="false"
                    aria-controls="collapse194"
                  >
                    <a
                      className="card-title lead info collapsed"
                      href={() => false}
                    >
                      <h3>Các loại phí</h3>
                    </a>
                  </div>
                  <div
                    id="collapse19417"
                    role="tabpanel"
                    aria-labelledby="headingCollapse9416"
                    className="card-collapse collapse"
                  >
                    <div className="card-content">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-12 col-lg-12">
                            {objListPhiKhac &&
                              objListPhiKhac.map((item, idx) => (
                                <div key={"phiKhac" + idx}>
                                  <div className="row">
                                    <div className="col-md-6">
                                      <NumberInput
                                        labelClass="col-md-6 label-control"
                                        inputClass="form-control input-sm"
                                        inputWrapClass="col-md-6"
                                        wrapperClass="form-group row"
                                        labelText={item.TenPhiKhac}
                                        inputProps={{
                                          name: "ListPhiKhac[" + idx + "].GiaTri",
                                          value: objListPhiKhac[idx].GiaTri,
                                          onChange: onChangePhiKhac(idx),
                                          control: control,
                                          readOnly: IsEditChoVay,
                                        }}
                                      ></NumberInput>
                                    </div>
                                    <div className="col-md-6">
                                      {item.LoaiPhiKhac == 1 ? (
                                        <>
                                          &nbsp;
                                          <br />
                                          <div className="col-md-12 radio-button-nhap-tien">
                                            <label className="custom-radio">
                                              <input
                                                type="radio"
                                                name={
                                                  "ListPhiKhac[" +
                                                  idx +
                                                  "].LoaiPhiKhac"
                                                }
                                                value="1"
                                                checked={true}
                                                disabled={true}
                                              />{" "}
                                              <span className="radio-mark"></span>
                                              Nhập tiền
                                            </label>
                                            <label
                                              className="custom-radio"
                                              style={{ paddingLeft: "10px" }}
                                            >
                                              <input
                                                type="radio"
                                                name={
                                                  "ListPhiKhac[" +
                                                  idx +
                                                  "].LoaiPhiKhac"
                                                }
                                                value="2"
                                                checked={false}
                                                disabled={true}
                                              />{" "}
                                              <span className="radio-mark"></span>
                                              Nhập %
                                            </label>
                                          </div>
                                        </>
                                      ) : item.LoaiPhiKhac == 2 ? (
                                        <>
                                          &nbsp;
                                          <br />
                                          <div
                                            className="col-md-12"
                                            style={{ paddingTop: "20px" }}
                                          >
                                            <label className="custom-radio">
                                              <input
                                                type="radio"
                                                name={
                                                  "ListPhiKhac[" +
                                                  idx +
                                                  "].LoaiPhiKhac"
                                                }
                                                value="1"
                                                checked={false}
                                                disabled={true}
                                              />{" "}
                                              <span className="radio-mark"></span>
                                              Nhập Tiền
                                            </label>
                                            <label
                                              className="custom-radio"
                                              style={{ paddingLeft: "10px" }}
                                            >
                                              <input
                                                type="radio"
                                                name={
                                                  "ListPhiKhac[" +
                                                  idx +
                                                  "].LoaiPhiKhac"
                                                }
                                                value="2"
                                                checked={true}
                                                disabled={true}
                                              />{" "}
                                              <span className="radio-mark"></span>
                                              Nhập %
                                            </label>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          &nbsp;
                                          <br />
                                          <div className="col-md-12 radio-button-nhap-tien">
                                            <label className="custom-radio">
                                              <input
                                                type="radio"
                                                name={
                                                  "ListPhiKhac[" +
                                                  idx +
                                                  "].LoaiPhiKhacChon"
                                                }
                                                value="1"
                                                checked={
                                                  objListPhiKhac[idx]
                                                    .LoaiPhiKhacChon === 1
                                                    ? true
                                                    : false
                                                }
                                                ref={register}
                                                disabled={IsEditChoVay}
                                                onChange={onChangeLoaiPhiKhac(
                                                  idx,
                                                  1
                                                )}
                                              />{" "}
                                              <span className="radio-mark"></span>
                                              Nhập tiền
                                            </label>
                                            <label
                                              className="custom-radio"
                                              style={{ paddingLeft: "10px" }}
                                            >
                                              <input
                                                type="radio"
                                                name={
                                                  "ListPhiKhac[" +
                                                  idx +
                                                  "].LoaiPhiKhacChon"
                                                }
                                                value="2"
                                                checked={
                                                  objListPhiKhac[idx]
                                                    .LoaiPhiKhacChon === 2
                                                    ? true
                                                    : false
                                                }
                                                ref={register}
                                                disabled={IsEditChoVay}
                                                onChange={onChangeLoaiPhiKhac(
                                                  idx,
                                                  2
                                                )}
                                              />{" "}
                                              <span className="radio-mark"></span>
                                              Nhập %
                                            </label>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                  <input
                                    type="hidden"
                                    name={
                                      "ListPhiKhac[" + idx + "].ConfigPhiKhacId"
                                    }
                                    value={item.ConfigPhiKhacId}
                                    ref={register}
                                  />
                                  <input
                                    type="hidden"
                                    name={"ListPhiKhac[" + idx + "].LoaiPhiKhac"}
                                    value={item.LoaiPhiKhac}
                                    ref={register}
                                  />
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>
                    {objListPhiKhacHangKy != undefined &&
                      objListPhiKhacHangKy.length > 0 && (
                        <>
                          <div
                            id="headingCollapse194121"
                            className="card-header  mt-1"
                            data-toggle="collapse"
                            href="#collapse194121"
                            aria-expanded="false"
                            aria-controls="collapse1941"
                          >
                            <a
                              className="card-title lead info collapsed"
                              href={() => false}
                            >
                              <h3>Các loại phí hàng kỳ</h3>
                            </a>
                          </div>
                          <div
                            id="collapse194121"
                            role="tabpanel"
                            aria-labelledby="headingCollapse194121"
                            className="card-collapse collapse"
                          >
                            <div className="card-content">
                              <div className="card-body">
                                <div className="row">
                                  <div className="col-md-12 col-lg-12">
                                    {objListPhiKhacHangKy &&
                                      objListPhiKhacHangKy.map((item, idx) => (
                                        <div key={"phiKhacHangKy" + idx}>
                                          <div className="row">
                                            <div className="col-md-6">
                                              <NumberInput
                                                labelClass="col-md-6 label-control"
                                                inputClass="form-control input-sm"
                                                inputWrapClass="col-md-6"
                                                wrapperClass="form-group row"
                                                labelText={item.TenPhiKhacHangKy}
                                                inputProps={{
                                                  name:
                                                    "ListPhiKhacHangKy[" +
                                                    idx +
                                                    "].GiaTri",
                                                  value:
                                                    objListPhiKhacHangKy[idx]
                                                      .GiaTri,
                                                  onChange:
                                                    onChangePhiKhacHangKy(idx),
                                                  control: control,
                                                }}
                                              ></NumberInput>
                                            </div>
                                            <div className="col-md-6">
                                              {item.LoaiPhiKhacHangKy == 1 ? (
                                                <>
                                                  &nbsp;
                                                  <br />
                                                  <div
                                                    className="col-md-12"
                                                    style={{ paddingTop: "20px" }}
                                                  >
                                                    <label className="custom-radio">
                                                      <input
                                                        type="radio"
                                                        name={
                                                          "ListPhiKhacHangKy[" +
                                                          idx +
                                                          "].LoaiPhiKhacHangKy"
                                                        }
                                                        value="1"
                                                        checked={true}
                                                        disabled={true}
                                                      />
                                                      <span className="radio-mark"></span>
                                                      Nhập tiền
                                                    </label>

                                                    <label
                                                      className="custom-radio"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        name={
                                                          "ListPhiKhacHangKy[" +
                                                          idx +
                                                          "].LoaiPhiKhacHangKy"
                                                        }
                                                        value="2"
                                                        checked={false}
                                                        disabled={true}
                                                      />
                                                      <span className="radio-mark"></span>
                                                      Nhập %
                                                    </label>
                                                  </div>
                                                </>
                                              ) : item.LoaiPhiKhacHangKy == 2 ? (
                                                <>
                                                  &nbsp;
                                                  <br />
                                                  <div className="col-md-12 radio-button-nhap-tien">
                                                    <label className="custom-radio">
                                                      <input
                                                        type="radio"
                                                        name={
                                                          "ListPhiKhacHangKy[" +
                                                          idx +
                                                          "].LoaiPhiKhacHangKy"
                                                        }
                                                        value="1"
                                                        checked={false}
                                                        disabled={true}
                                                      />
                                                      <span className="radio-mark"></span>
                                                      Nhập tiền
                                                    </label>
                                                    <label
                                                      className="custom-radio"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        name={
                                                          "ListPhiKhacHangKy[" +
                                                          idx +
                                                          "].LoaiPhiKhacHangKy"
                                                        }
                                                        value="2"
                                                        checked={true}
                                                        disabled={true}
                                                      />
                                                      <span className="radio-mark"></span>
                                                      Nhập %
                                                    </label>
                                                  </div>
                                                </>
                                              ) : (
                                                <>
                                                  &nbsp;
                                                  <br />
                                                  <div className="col-md-12 radio-button-nhap-tien">
                                                    <label className="custom-radio">
                                                      <input
                                                        type="radio"
                                                        name={
                                                          "ListPhiKhacHangKy[" +
                                                          idx +
                                                          "].LoaiPhiKhacHangKyChon"
                                                        }
                                                        value="1"
                                                        checked={
                                                          objListPhiKhacHangKy[
                                                            idx
                                                          ]
                                                            .LoaiPhiKhacHangKyChon ===
                                                          1
                                                            ? true
                                                            : false
                                                        }
                                                        ref={register}
                                                        disabled={IsEditChoVay}
                                                        onChange={onChangeLoaiPhiKhacHangKy(
                                                          idx,
                                                          1
                                                        )}
                                                      />
                                                      <span className="radio-mark"></span>
                                                      Nhập tiền
                                                    </label>

                                                    <label
                                                      className="custom-radio"
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        name={
                                                          "ListPhiKhacHangKy[" +
                                                          idx +
                                                          "].LoaiPhiKhacHangKyChon"
                                                        }
                                                        value="2"
                                                        checked={
                                                          objListPhiKhacHangKy[
                                                            idx
                                                          ]
                                                            .LoaiPhiKhacHangKyChon ===
                                                          2
                                                            ? true
                                                            : false
                                                        }
                                                        ref={register}
                                                        disabled={IsEditChoVay}
                                                        onChange={onChangeLoaiPhiKhacHangKy(
                                                          idx,
                                                          2
                                                        )}
                                                      />
                                                      <span className="radio-mark"></span>
                                                      Nhập %
                                                    </label>
                                                  </div>
                                                </>
                                              )}
                                            </div>
                                          </div>
                                          <input
                                            type="hidden"
                                            name={
                                              "ListPhiKhacHangKy[" +
                                              idx +
                                              "].ConfigPhiKhacHangKyId"
                                            }
                                            value={item.ConfigPhiKhacHangKyId}
                                            ref={register}
                                          />
                                          <input
                                            type="hidden"
                                            name={
                                              "ListPhiKhacHangKy[" +
                                              idx +
                                              "].LoaiPhiKhacHangKy"
                                            }
                                            value={item.LoaiPhiKhacHangKy}
                                            ref={register}
                                          />
                                        </div>
                                      ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                  </div>
                </div>
                {!isCauHinhT77 && (
                  <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                    <div
                      id="headingCollapse19412"
                      className="card-header  mt-1"
                      data-toggle="collapse"
                      href="#collapse19413"
                      aria-expanded="false"
                      aria-controls="collapse19413"
                    >
                      <a
                        className="card-title lead info collapsed"
                        href={() => false}
                      >
                        <h3>Bổ sung giấy tờ tín chấp vay</h3>
                      </a>
                    </div>
                    <div
                      id="collapse19413"
                      role="tabpanel"
                      aria-labelledby="headingCollapse9412"
                      className="card-collapse collapse"
                    >
                      <div className="card-content">
                        <div className="card-body">
                          <div className="row">
                            <label class="col-md-4 color7-bold">
                              Giấy tờ tín chấp
                            </label>
                            <br />
                            <div className="col-md-12">
                              <input
                                type="text"
                                className="form-control input-sm"
                                placeholder="1 CMT + 1 GPLX"
                                name="NoteTaiSan"
                                ref={register}
                                readOnly={IsEditChoVay}
                              />
                            </div>
                          </div>
                          <br />
                          <div className="row">
                            <div className="col-md-12">
                              <UploadMultiFile
                                Files={imageTaiSans}
                                onChange={setImageTaiSans}
                                Code={thongTinCuaHang.Code}
                              ></UploadMultiFile>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {isCauHinhT77 && (
                  <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                    <div
                      id="headingCollapse191"
                      className="card-header  mt-1"
                      data-toggle="collapse"
                      href="#collapse191"
                      aria-expanded="false"
                      aria-controls="collapse191"
                    >
                      <a
                        className="card-title lead info collapsed"
                        href={() => false}
                      >
                        <h3>Thông tin tài sản</h3>
                      </a>
                    </div>
                    <div
                      id="collapse191"
                      role="tabpanel"
                      aria-labelledby="headingCollapse191"
                      className="card-collapse collapse"
                    >
                      <div className="card-content">
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-12">
                              <input
                                type="hidden"
                                name="ListHangTheChap[0].CategoryId"
                                value={CategoryId || ""}
                                ref={register}
                              ></input>
                              <div className="row">
                                {ThuocTinhTaiSan &&
                                  ThuocTinhTaiSan.map((item, index) => (
                                    <div
                                      className="col-md-3"
                                      key={"Thuoctinhts1" + index}
                                    >
                                      <TextInputOnRow
                                        labelClass="label-control color7-bold"
                                        inputClass="form-control input-sm"
                                        wrapperClass="form-group"
                                        labelText={item.TenThuocTinh}
                                        inputProps={{
                                          ref: register,
                                          name:
                                            "ListHangTheChap[0].ThuocTinhTaiSan[" +
                                            index +
                                            "].OptionValue",
                                          onChange: onChangeThuocTinhTaiSan(index),
                                          value:
                                            ThuocTinhTaiSan[index].OptionValue,
                                        }}
                                      ></TextInputOnRow>
                                      <input
                                        type="hidden"
                                        name={
                                          "ListHangTheChap[0].ThuocTinhTaiSan[" +
                                          index +
                                          "].OptionName"
                                        }
                                        value={item.MaThuocTinh}
                                        ref={register}
                                      ></input>
                                    </div>
                                  ))}
                                <div className="col-md-3">
                                  <div className="form-group">
                                    <label className="label-control color7-bold">
                                      Kho
                                    </label>
                                    <select
                                      name="ListHangTheChap[0].StoreID"
                                      className="selectBox form-control input-sm select-v2"
                                      ref={register}
                                      value={StoreID || ""}
                                      onChange={setAttTaiSan("StoreID")}
                                    >
                                      {objComboStore &&
                                        objComboStore.map((item, idx) => (
                                          <option
                                            key={"objComboStore1" + idx}
                                            value={item.value}
                                          >
                                            {item.label}
                                          </option>
                                        ))}
                                    </select>
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <TextInputOnRow
                                    labelClass="label-control color7-bold"
                                    inputClass="form-control input-sm"
                                    wrapperClass="form-group"
                                    labelText="Mã tài sản"
                                    inputProps={{
                                      ref: register,
                                      name: "ListHangTheChap[0].Code",
                                      onChange: setAttTaiSan("MaTaiSan"),
                                      value: MaTaiSan || "",
                                    }}
                                  ></TextInputOnRow>
                                </div>
                                {ConfigPhiKho === 1 && (
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label className="label-control color7-bold">
                                        Phí kho/ngày
                                      </label>
                                      <NumberFormat
                                        thousandSeparator={true}
                                        prefix={""}
                                        inputMode="numeric"
                                        className="form-control input-sm"
                                        placeholder="%"
                                        name="ListHangTheChap[0].PhiKho"
                                        onChange={setAttTaiSan("PhiKho")}
                                        value={PhiKho || ""}
                                        getInputRef={register}
                                      />
                                    </div>
                                  </div>
                                )}
                                <div
                                  className="col-md-12"
                                  style={{ marginTop: "10px" }}
                                >
                                  <div className="form-group">
                                    <label className="label-control color7-bold">
                                      Ghi chú
                                    </label>
                                    <textarea
                                      rows="1"
                                      style={{ minHeight: "80px" }}
                                      className="form-control input-sm text-era"
                                      name="ListHangTheChap[0].Note"
                                      placeholder="Ghi chu"
                                      ref={register}
                                      onChange={setAttTaiSan("Note")}
                                      value={NoteTaiSan || ""}
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12 mt-1">
                              <div className="row">
                                <div className="col-md-12">
                                  <UploadMultiFile
                                    Files={imageTaiSans}
                                    onChange={setImageTaiSans}
                                    Code={thongTinCuaHang.Code}
                                  ></UploadMultiFile>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="form-group overflow-hidden form-actions text-right">
                          <button
                            type="button"
                            className="btn-them-moi-ts"
                            onClick={onClickShowAddNewTaiSan}
                            style={{ margin: "0px" }}
                          >
                            <i className="mdi mdi-plus"></i>{" "}
                            <span style={{ fontSize: "15px" }}>
                              Thêm mới tài sản khác
                            </span>
                          </button>
                        </div>
                        <div className={showAddNewTaiSan ? "" : "hidden"}>
                          <ListTaiSanForm
                            comboLoaiTaiSan={ListLoaiTaiSan}
                            getThuocTinhTaiSan1={getThuocTinhTaiSan1}
                            loadThuocTinhTaiSan={getThuocTinhTaiSan}
                            listTaiSan={ListTaiSanCamCo}
                            onChange={onChangeListTaiSan}
                            thuoctinhtaisan={thuoctinhtaisan}
                            thuocTinhTaiSanData={objThuocTinhTaiSan}
                            thuocTinhTaiSanLoaded={thuocTinhTaiSanLoaded}
                            objComboStore={objComboStore}
                            cauHinhPhiKho={PhiKho}
                            codeCuaHang={thongTinCuaHang.Code}
                          ></ListTaiSanForm>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                  <div
                    id="headingCollapse191191"
                    className="card-header  mt-1"
                    data-toggle="collapse"
                    href="#collapse191191"
                    aria-expanded="false"
                    aria-controls="collapse194"
                  >
                    <a
                      className="card-title lead info collapsed"
                      href={() => false}
                    >
                      <h3>Đính kèm file</h3>
                    </a>
                  </div>
                  <div
                    id="collapse191191"
                    role="tabpanel"
                    aria-labelledby="headingCollapse9412"
                    className="card-collapse collapse"
                  >
                    <div className="card-content">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-12 col-lg-12">
                            <UploadMultiFile1
                              Files={fileDinhKems}
                              onChange={setFileDinhKems}
                              Code={thongTinCuaHang.Code}
                            ></UploadMultiFile1>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="modal-footer button-popup-new-size">
            <button className="btn btn-new-main btn-checknew" type="submit">
              <span className="btn-icon-left">
                <i className="mdi mdi-check"></i>
              </span>{" "}
              {laiho_sudungchoduyet ? "Chờ duyệt" : "Lưu lại"}
            </button>
            {/* {showButtonIn && (
              <button
                className="btn btn-new-main btn-checknew"
                href={() => false}
                onClick={inHopDong(choVayEdit)}
                type="button"
              >
                <span className="btn-icon-left">
                  <i className="mdi mdi-printer"></i>
                </span>{" "}
                In hợp đồng
              </button>
            )}

            {showButtonInPhieuThu && (
              <button
                className="btn btn-new-main btn-checknew"
                href={() => false}
                onClick={inPhieuThu(ThuChiId)}
                type="button"
              >
                <span className="btn-icon-left">
                  <i className="mdi mdi-printer"></i>
                </span>{" "}
                In phiếu thu
              </button>
            )} */}

            <button
              className="btn btn-new-main btn-closenew"
              data-dismiss="modal"
              href={() => false}
              onClick={closeThemMoi()}
              type="button"
            >
              <span className="btn-icon-left">
                <i className="mdi mdi-close"></i>
              </span>{" "}
              Đóng
            </button>
          </Modal.Footer>
        </form>
      </Modal>
      {isShowModalLoaiTaiSan && (
        <ThemMoiLoaiTaiSanContainer
          show={isShowModalLoaiTaiSan}
          onHide={hideModalLoaiTaiSan}
        ></ThemMoiLoaiTaiSanContainer>
      )}
    </>
  );
};
export default ThemMoiTraGop;
